import {Component, Input, OnInit} from '@angular/core';

// Dmitry Berezhnov
// зачем мы отсюда идём в бэкенд?
// 
// Maxim Nikishin
// Чтобы вычислять кластер
// Это универсальный компонент. Не везде на клиенте у нас есть(можем получить) данные о кластере
@Component({
	selector: 'gotosupport',
	template: `
		<a
			target="_blank"
			rel="noreferrer"
			[routerLink]="['/api/support/negotiator/gotosupport' + (_value ? '?value=' + _value : '')]"
			[queryParams]="queryParams"
		>
			<ng-content></ng-content>
			<ng-template [ngIf]="title">
				{{ title }}
			</ng-template>
		</a>
	`,
})
export class GoToSupportComponent implements OnInit {
	@Input('value') _value: string = '';
	@Input('title') _title: string = '';
	@Input('queryParams') queryParams: object = null;

	title: string = '';

	constructor() {
		
	}

	ngOnInit() {
		this.title = this._title === '' ? `${this._value}` : this._title;
	}
}
